module.exports = __webpack_public_path__ + "img/slika39.919be7ec.jpg";